
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Head from './component/header';
import './assets/css/style.css'
import './assets/css/bootstrap.min.css'
import Home from './component/home';
import Footer from './component/footer';
import './assets/css/animate.css'
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Head />
        <Routes>
          <Route path='/' element={<Home />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <ToastContainer limit={1}/>
    </div>
  );
}

export default App;
